(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/event-comment.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/event-comment.js');
"use strict";

const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  selectSportEvent
} = svs.components.sportinfo.matchInfoRedux.selectors;
const {
  useSelector
} = ReactRedux;
const {
  getIsCancelled
} = svs.components.sportinfo.common.matchState;
const {
  drawStateEnums
} = svs.components.sport.tipsenShared;
const {
  getEventCommentForCancelledGame
} = svs.components.tipsen.couponStatic.utils;
const EventComment = _ref => {
  let {
    drawEvent,
    drawNumber,
    drawState,
    productId
  } = _ref;
  const {
    data
  } = useDrawResults({
    productId,
    drawNumber
  });
  const [currentDrawResult] = data;
  const eventNumber = drawEvent.eventNumber ? drawEvent.eventNumber : undefined;
  const drawIsFinalized = drawState ? drawState === drawStateEnums.FINALIZED : undefined;
  const currentMatchId = (drawEvent === null || drawEvent === void 0 ? void 0 : drawEvent.matchId) || undefined;
  const sportEvent = useSelector(state => selectSportEvent(state, currentMatchId));
  const isCancelled = sportEvent ? getIsCancelled(sportEvent.sportEventStatus) : undefined;
  let eventComment = !drawIsFinalized && !isCancelled && drawEvent ? drawEvent.eventComment : undefined;
  const currentDrawResultIsCancelled = currentDrawResult === null || currentDrawResult === void 0 ? void 0 : currentDrawResult.find(res => (res === null || res === void 0 ? void 0 : res.cancelled) && (res === null || res === void 0 ? void 0 : res.eventNumber) === eventNumber);
  if ((isCancelled || currentDrawResultIsCancelled) && currentDrawResult && Object.keys(currentDrawResult).length > 0) {
    const resultForCurrentEvent = currentDrawResult[eventNumber - 1];
    eventComment = getEventCommentForCancelledGame({
      resultForCurrentEvent,
      productId
    });
  }
  if (!eventComment) {
    return null;
  }
  return React.createElement("div", {
    className: "pg_coupon_static__event_comment fc-red"
  }, React.createElement("span", null, eventComment));
};
setGlobal('svs.components.tipsen.couponStatic.EventComment', EventComment);

 })(window);